<div class="alert alert-info fade show" role="alert">
  <div class="flex flex-wrap justify-content-between align-items-center"  >

    <strong *ngIf="currentConference$ | async as conf">Текущая конференция: {{ conf.name }}</strong>
    <strong *ngIf="!(currentConference$ | async)">Текущая конференция не определена</strong>
    <div>
      <button pButton (click)="onChangeCurrentConference()" class="mb-1" label="Выбрать конференцию"></button>
      <button pButton class="p-button-secondary mb-1" (click)="onResetCurrentConference()" label="Сбросить"></button>
    </div>


  </div>

</div>
<div *ngIf="showDialog" class="card mb-2">
  <div class="card-body">
    <form class="flex flex-row gap-3">
      <div class="p-fluid flex-grow-1">
        <div class="p-field">
          <p-dropdown [options]="items$ | async" [(ngModel)]="selected" [filter]="true"
          placeholder="Выберите текущую конференцию" [autoDisplayFirst]="false"
          optionLabel="name" name="selectedconference">
          </p-dropdown>
        </div>
      </div>
      <button pButton class="p-button-success" icon="pi pi-check" label="Сохранить" type="submit"
        (click)="onSubmit(selected)"></button>
      <button pButton type="button" icon="pi pi-ban" class="p-button-secondary" label="Закрыть"
        (click)="onCancel()"></button>
    </form>
  </div>
</div>
